// extracted by mini-css-extract-plugin
module.exports =  {"button":"button-teWrC","text":"text-RJAMZ","icon":"icon-dercP","open":"open-N55hq","label-icon":"label-icon-vM8_6"};